<template>
  <ul>
    <menu-options-item close label="Abrir" @click="$emit('abrir')" icon="folder-open" />
    <menu-options-item close label="Consultar comitente" />
    <menu-options-item close label="Consultar reboquista" />
    <menu-options-item close label="Gerar vistoria" @click.native="gerarVistoriaRemocao" />
  </ul>
</template>

<script>
import MenuOptionsItem from '../../../layout/context-menu/context-window-options-item'
import {gerarVistoriaRemocao} from '@/domain/remocao/services'
export default {
  name: 'remocao-list-menu',
  props: ['remocao'],
  components: {MenuOptionsItem},
  methods: {
    gerarVistoriaRemocao () {
      this.$uloc.loading.show()
      gerarVistoriaRemocao(this.remocao.id)
          .then((data) => {
            console.log(data)
            this.$uloc.loading.hide()
            this.dg()
          })
          .catch(error => {
            this.$uloc.loading.hide()
            this.alertApiError(error)
          })
    }
  }
}
</script>
